var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3291 25.436V26.257C1.3291 26.6103 1.46944 26.9491 1.71924 27.1989C1.96903 27.4487 2.30783 27.589 2.6611 27.589H21.3371C21.6902 27.5888 22.0287 27.4483 22.2783 27.1985C22.5279 26.9488 22.6681 26.6101 22.6681 26.257V22.296C22.6682 21.4835 22.4052 20.6927 21.9185 20.042C21.4318 19.3913 20.7476 18.9156 19.9681 18.686L18.2681 18.186L12.0021 21.909L5.7291 18.187L4.0291 18.687C3.24962 18.9166 2.56538 19.3923 2.0787 20.043C1.59202 20.6937 1.32904 21.4845 1.3291 22.297V23.519",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.265 18.1873L14.453 15.6973C14.4531 17.2902 13.9907 18.849 13.122 20.1843L11.999 21.9103",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7334 18.1872L9.5454 15.7012C9.54536 17.2941 10.0077 18.8529 10.8764 20.1882L11.9994 21.9142",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.543 6.91113V8.14913C8.543 8.38783 8.44818 8.61675 8.2794 8.78553C8.11061 8.95431 7.8817 9.04913 7.643 9.04913H6.75V10.5201C6.75 10.7007 6.82175 10.874 6.94946 11.0017C7.07717 11.1294 7.25039 11.2011 7.431 11.2011C7.48805 11.2013 7.54289 11.2232 7.58433 11.2624C7.62577 11.3016 7.65069 11.3552 7.654 11.4121C7.72466 12.5167 8.21327 13.553 9.02053 14.3103C9.8278 15.0676 10.8931 15.4891 12 15.4891C13.1067 15.4886 14.1717 15.0667 14.9785 14.3093C15.7854 13.5518 16.2736 12.5156 16.344 11.4111C16.3476 11.3537 16.3732 11.2998 16.4155 11.2607C16.4577 11.2216 16.5134 11.2002 16.571 11.2011C16.7516 11.2011 16.9248 11.1294 17.0525 11.0017C17.1803 10.874 17.252 10.7007 17.252 10.5201V9.04913H16.359C16.1203 9.04913 15.8914 8.95431 15.7226 8.78553C15.5538 8.61675 15.459 8.38783 15.459 8.14913V6.91113",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54297 14.731V15.698",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 15.6979V14.7329",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5871 4.08612L12.9811 3.88612C12.3292 3.80554 11.6699 3.80554 11.0181 3.88612L7.39107 4.33512L6.41507 4.45612V6.50812C6.41384 6.604 6.44709 6.69713 6.50876 6.77055C6.57043 6.84396 6.65642 6.89279 6.75107 6.90812C6.77287 6.91192 6.79494 6.91392 6.81707 6.91412H17.1841C17.2055 6.9138 17.2269 6.9118 17.2481 6.90812C17.3431 6.89322 17.4296 6.84458 17.4916 6.77112C17.5537 6.69766 17.5872 6.60429 17.5861 6.50812V4.45712L16.6081 4.33612L16.4931 4.32212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2471 9.05025V6.90625",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74902 6.90625V9.05025",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5837 4.45708L20.3927 3.97907C20.4948 3.961 20.5879 3.90931 20.6573 3.83223C20.7267 3.75515 20.7682 3.6571 20.7755 3.55367C20.7827 3.45023 20.7552 3.34734 20.6972 3.26135C20.6393 3.17535 20.5543 3.1112 20.4557 3.07907L12.1387 0.433075C12.047 0.403819 11.9484 0.403819 11.8567 0.433075L3.53968 3.07407C3.44109 3.1062 3.35608 3.17036 3.29813 3.25635C3.24019 3.34234 3.21264 3.44523 3.21989 3.54867C3.22713 3.65211 3.26875 3.75015 3.33811 3.82723C3.40747 3.90431 3.50059 3.956 3.6027 3.97408L6.4127 4.45307",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68273 8.43604L2.12873 11.688C2.1159 11.7606 2.11927 11.8351 2.13858 11.9062C2.1579 11.9773 2.19269 12.0432 2.24046 12.0993C2.28823 12.1554 2.34781 12.2002 2.41494 12.2306C2.48206 12.261 2.55506 12.2762 2.62873 12.275H4.48473C4.5584 12.2762 4.6314 12.261 4.69853 12.2306C4.76565 12.2002 4.82523 12.1554 4.873 12.0993C4.92078 12.0432 4.95557 11.9773 4.97488 11.9062C4.9942 11.8351 4.99756 11.7606 4.98473 11.688L4.42273 8.43604",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42357 7.29398C4.42357 7.17755 4.37732 7.06589 4.29499 6.98356C4.21266 6.90123 4.101 6.85498 3.98457 6.85498H3.12357C3.00714 6.85498 2.89548 6.90123 2.81315 6.98356C2.73082 7.06589 2.68457 7.17755 2.68457 7.29398V8.43598H4.42457L4.42357 7.29398Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0902 18.1089C13.4032 18.2576 12.7021 18.3317 11.9992 18.3299C11.296 18.3317 10.5946 18.2576 9.90723 18.1089",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.ec71163451006bb4ec513605c1776812.svg";
export { ForwardRef as ReactComponent };